module.exports = __webpack_public_path__ + "static/pic11-e3dc8bca31ea57ba22bbaf848ae9f7c4.jpg";